import { Outlet, createFileRoute } from "@tanstack/react-router"

import { DashboardLayout } from "@/components/layout/dashboard-layout"
import { requireAuth } from "@/lib/auth/route-guards"

/**
 * Pathless layout for every module the customer can reach (`/voxlane/*`,
 * `/sift/*`). `beforeLoad` gates the whole subtree: no valid session →
 * bounce to `/login` (remembering `?from=`). The resolved user is
 * returned into the route context for children.
 *
 * Pathless (`_shell`) on purpose: it adds no URL segment and sits ABOVE
 * the module segment, so switching stations keeps the same layout
 * instance mounted instead of remounting and flickering the sidebar.
 */
export const Route = createFileRoute("/_shell")({
  beforeLoad: ({ context, location }) => requireAuth({ context, location }),
  component: DashboardRoute,
})

function DashboardRoute() {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  )
}
